import { Text, Stack, Flex, Box, Heading, Button, Image } from "@chakra-ui/core";
import { Link } from "gatsby";
import { A } from "components/A";
import { Card } from "components/Card";
import { Newsletter } from "components/Newsletter";
import { ButtonGroup } from "components/ButtonGroup";
import { OGImage } from "components/OG";
import { SponsorsList } from "components/Sponsors";
import * as React from 'react';
export default {
  Text,
  Stack,
  Flex,
  Box,
  Heading,
  Button,
  Image,
  Link,
  A,
  Card,
  Newsletter,
  ButtonGroup,
  OGImage,
  SponsorsList,
  React
};